export default "/images/vendor/flag-icons/flags/1x1/kn.svg?ee4fa5925824ae121bd00bb04f0287f6";